import * as React from 'react';
import * as _ from "lodash";
import { SaveButton } from './styles';
import InnerLoader from 'components/InnerLoader';

export const DepartmentsButtons = (props) => {

    return (
        <>
            { renderButton()}
        </>
    )


    function renderButton() {
        if (props.renderType == 2)  
            return (
                <SaveButton onClick={() => {
                    if (props.departments?.urlcms)
                        window.open(props.departments?.urlcms, "_blank");
                }}>
                    Back to CMS
                </SaveButton>
            )
        else if (props.renderType == 1)
            return (
                <SaveButton onClick={() => {
                    if (props.departments?.urlcms)
                        window.open(props.departments?.urlsupport, "_blank");
                }}>
                    Contact Support
                </SaveButton>
            )
        else {
            return (
                <SaveButton onClick={props.onSaveClick} disabled={saveDisabled()}>
                    {
                    props.isSaving?
                        <InnerLoader backgroundColor={"#FFF"}></InnerLoader>
                        :
                        'Save Changes'
                    }
                </SaveButton>
            )
        }
    }

    function saveDisabled() {
        return false
    }


}